import "./EmergencyPlumbingProblems.module.css";
import Header from "@/reusable_sections/Header";
import EmergencySituations from "./sections/EmergencySituations";
import Symptoms from "./sections/Symptoms";
import ServiceArea from "./sections/ServiceArea";
import Footer from "@/reusable_sections/Footer";
export default function EmergencyPlumbingProblemsPage() {
  return <div>
      <Header />
      <EmergencySituations />
      <Symptoms />
      <ServiceArea />
      <Footer />
    </div>;
}